import { declareEntity } from '../fw/MetaDataHelper.ts';
import { v4 as uuidv4 } from 'uuid';

export default declareEntity({
    name: 'OverdueBillsSetting',
    entity: 'overdueBillsSettings',
    graphQL: 'OverdueBillsSetting',
    storageType: 'schema',
    defaultTitle: () => 'Overdue Bills Settings',
    fields: (types) => ({
        id: { type: 'id', defaultValue: () => uuidv4(), primaryKey: true, required: true, userEditable: false },
        instance: { name: 'Instance', type: 'relation', to: () => types['instances'], required: true, userEditable: false },
        mustHaveLabels: { type: 'string', required: false, userEditable: true, description: 'CSV labels that must be present on Flexi invoices' },
        notHaveLabels: { type: 'string', required: false, userEditable: true, description: 'CSV labels that must NOT be present on Flexi invoices' },
        ignoreLabel: { type: 'string', required: false, userEditable: true, description: 'Label code that marks invoices for automatic ignore (e.g. IGNORE-AUTO)' },
        lastUpdate: { type: 'datetime', required: false, userEditable: true, description: 'Checkpoint of last successful Flexi invoices sync' },
		lastChangeVersion: { type: 'string', required: false, userEditable: true, description: 'Flexi changes API version checkpoint' },
        flexiChannelId: { type: 'string', required: false, userEditable: true, description: 'Flexi channel ID used for REST calls' },
        helpdeskPhone: { type: 'string', required: false, userEditable: true, description: 'Helpdesk phone number used in notifications' },
        helpdeskEmail: { type: 'string', required: false, userEditable: true, description: 'Helpdesk email used in notifications (e.g. CC)' },
        dryRun: { type: 'boolean', required: false, userEditable: true, description: 'When enabled, rules execute normally but no emails/SMS are sent (logging only)', defaultValue: () => false },
        createdAt: { type: 'datetime', defaultValue: () => new Date(), userEditable: false },
        updatedAt: { type: 'datetime', defaultValue: () => new Date(), userEditable: false },
    }),
});


